/* The Tasks filter (chat tasks M2.4, GH #3041) */
.list {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  padding: 0 var(--tuna-spacing-1_5) var(--tuna-spacing-1);
}

.items {
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  padding: var(--tuna-spacing-0_5) 0;
}

/* An anchored task's place, as its group's header reads */
.anchor {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  min-width: 0;
}

.heading {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-palette-text-primary);
}

.show,
.doneToggle {
  flex: 0 0 auto;
  border: 0;
  background: none;
  padding: var(--tuna-spacing-0_5) var(--tuna-spacing-1);
  border-radius: var(--tuna-shape-borderRadius);
  font: inherit;
  font-size: var(--tuna-typography-body2-fontSize);
  cursor: pointer;
}

.show {
  color: var(--tuna-palette-primary-main);
}

.doneToggle {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-0_5);
  color: var(--tuna-palette-text-secondary);
}

.chevron {
  display: inline-flex;
  font-size: var(--tuna-typography-body2-fontSize);
}

.chevron svg {
  width: 1.25em;
  height: 1.25em;
}

.show:hover,
.doneToggle:hover {
  background-color: var(--tuna-palette-action-hover);
}

.show:focus-visible,
.doneToggle:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

@media (pointer: coarse) {
  .show,
  .doneToggle {
    min-height: 44px;
  }
}

.empty {
  margin: var(--tuna-spacing-2) var(--tuna-spacing-1_5);
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-palette-text-secondary);
}
